import {uniqBy} from 'lodash';

import {TagDataType} from './reviews-tags';
import {ReviewDataTagType} from './reviews-type';

function tagDataToReviewDataTag(tag: TagDataType): ReviewDataTagType {
    return {
        id: tag.id,
        title: tag.title,
        isAspect: false,
        folderId: tag.folder?.id ?? null,
    };
}

export function mergeBulkTagsIntoReview(
    existingTags: Array<ReviewDataTagType> | null | undefined,
    addedTags: Array<TagDataType>
): Array<ReviewDataTagType> {
    const existing = existingTags ?? [];
    const appended = addedTags.map(tagDataToReviewDataTag);

    return uniqBy([...existing, ...appended], (tag) => tag.id);
}
